export const showAddPaymentOptionModal = () => {
    return {
      type: "SHOW_ADD_PAYMENT_OPTION_MODAL",
    };
  };
  
  export const hideAddPaymentOptionModal = () => {
    return {
      type: "HIDE_ADD_PAYMENT_OPTION_MODAL",
    };
  };
  